import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgCross(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M5.3 6.70002C4.90001 6.29999 4.89999 5.7 5.29997 5.29995C5.69999 4.89999 6.30001 4.90002 6.7 5.30003L11.9999 10.5858L17.3 5.3C17.7 4.9 18.3 4.9 18.7 5.3C19.1 5.7 19.1 6.3 18.7 6.7L13.4141 12L18.7 17.3C19.1 17.7 19.1 18.3 18.7 18.7C18.3 19.1 17.7 19.1 17.3 18.7L11.9999 13.4142L6.7 18.7C6.3 19.1 5.7 19.1 5.3 18.7C4.9 18.3 4.9 17.7 5.3 17.3L10.5857 12L5.3 6.70002Z", fill: "currentColor" })));
}
export default SvgCross;
